import { actionCreator } from 'utils';
import * as PropertyTypes from '../types/propertyTypes';


// L O A D   P R O P E R T I E S
export function loadProperties() {
    return {
        type: PropertyTypes.LOAD_PROPERTIES,
    };
}

export function loadPropertiesRes(data) {
    return {
        type: actionCreator(PropertyTypes.LOAD_PROPERTIES, 'res'),
        data,
    };
}

export function loadPropertiesErr() {
    return {
        type: actionCreator(PropertyTypes.LOAD_PROPERTIES, 'err'),
    };
}

export function setPropertiesPagination(key, pagination) {
    return {
        type: PropertyTypes.SET_PROPERTY_PAGINATION,
        key,
        pagination,
    };
}

export function setPropertiesSort(key, type) {
    return {
        type: PropertyTypes.SET_PROPERTY_SORT,
        sort: {
            key,
            type,
        },
    };
}
// L O A D   P R O P E R T I E S


// S E T   P R O P E R T Y    F I L T E R
export function setPropertyFilters(key, value) {
    return {
        type: PropertyTypes.SET_PROPERTY_FILTER,
        key,
        value,
    };
}

export function setPropertyFiltersRes(data) {
    return {
        type: actionCreator(PropertyTypes.SET_PROPERTY_FILTER, 'res'),
        data,
    };
}
// S E T   P R O P E R T Y    F I L T E R


// S E T   P R O P E R T Y   T Y P E   F I L T E R
export function setPropertyTypeFilters(key) {
    return {
        type: PropertyTypes.SET_PROPERTY_TYPE_FILTER,
        key,
    };
}

export function setPropertyTypeFiltersRes(data) {
    return {
        type: actionCreator(PropertyTypes.SET_PROPERTY_TYPE_FILTER, 'res'),
        data,
    };
}
// S E T   P R O P E R T Y   T Y P E   F I L T E R


// R E S T    F I L T E R    P R O P E R T I E S
export function resetFiltersProperties() {
    return {
        type: PropertyTypes.RESET_FILTER_PROPERTIES,
    };
}

export function resetFiltersPropertiesRes(data) {
    return {
        type: actionCreator(PropertyTypes.RESET_FILTER_PROPERTIES, 'res'),
        data,
    };
}
// R E S T    F I L T E R    P R O P E R T I E S


// A D D   N E W  P R O P R I E T Y
export function addNewProperty(data) {
    return {
        type: PropertyTypes.ADD_NEW_PROPERTY,
        data,
    };
}

export function addNewPropertyRes(loading) {
    return {
        type: actionCreator(PropertyTypes.ADD_NEW_PROPERTY, 'res'),
        loading,
    };
}

export function addNewPropertyErr(error) {
    return {
        type: actionCreator(PropertyTypes.ADD_NEW_PROPERTY, 'err'),
        error,
    };
}

export function goToStepOfPropertyForm(step, propertyID) {
    return {
        type: PropertyTypes.GO_TO_STEP_OF_PROPERTY_FORM,
        step,
        propertyID,
    };
}
// A D D   N E W   P R O P R I E T Y


// U P D A T E   T R A N S L A T E   P R O P R I E T Y
export function updateTranslateProperty() {
    return {
        type: PropertyTypes.UPDATE_TRANSLATE_PROPERTY,
    };
}

export function updateTranslatePropertyRes(key, loading, success) {
    return {
        type: actionCreator(PropertyTypes.UPDATE_TRANSLATE_PROPERTY, 'res'),
        key,
        loading,
        success,
    };
}
// U P D A T E   T R A N S L A T E   P R O P R I E T Y


// A D D   P R O P R I E T Y   V A L U E   T O   P R O P R I E T Y
export function addPropertyValueToProperty(data) {
    return {
        type: PropertyTypes.ADD_PROPERTY_VALUE_TO_PROPERTY,
        data,
    };
}

export function addPropertyValueToPropertyRes(success) {
    return {
        type: actionCreator(PropertyTypes.ADD_PROPERTY_VALUE_TO_PROPERTY, 'res'),
        success,
    };
}

export function addPropertyValueToPropertyErr(error) {
    return {
        type: actionCreator(PropertyTypes.ADD_PROPERTY_VALUE_TO_PROPERTY, 'err'),
        error,
    };
}
// A D D   P R O P R I E T Y   V A L U E   T O   P R O P R I E T Y


// E D I T   P R O P R I E T Y   V A L U E   T O   P R O P R I E T Y
export function editPropertyValueToProperty(data) {
    return {
        type: PropertyTypes.EDIT_PROPERTY_VALUE_TO_PROPERTY,
        data,
    };
}

export function editPropertyValueToPropertyRes(success) {
    return {
        type: actionCreator(PropertyTypes.EDIT_PROPERTY_VALUE_TO_PROPERTY, 'res'),
        success,
    };
}

export function editPropertyValueToPropertyErr(error) {
    return {
        type: actionCreator(PropertyTypes.EDIT_PROPERTY_VALUE_TO_PROPERTY, 'err'),
        error,
    };
}
// E D I T   P R O P R I E T Y   V A L U E   T O   P R O P R I E T Y


// L O A D   E D I T A B L E   P R O P E R T Y
export function loadEditableProperty(id) {
    return {
        type: PropertyTypes.LOAD_EDITABLE_PROPERTY,
        id,
    };
}

export function loadEditablePropertyRes(data) {
    return {
        type: actionCreator(PropertyTypes.LOAD_EDITABLE_PROPERTY, 'res'),
        data,
    };
}

export function loadEditablePropertyErr() {
    return {
        type: actionCreator(PropertyTypes.LOAD_EDITABLE_PROPERTY, 'err'),
    };
}

export function setEmptyEditableProperty() {
    return {
        type: PropertyTypes.SET_EMPTY_EDITABLE_PROPERTY,
    };
}
// L O A D   E D I T A B L E   P R O P E R T Y


// E D I T   P R O P E R T Y
export function editProperty(data) {
    return {
        type: PropertyTypes.EDIT_PROPERTY,
        data,
    };
}

export function editPropertyRes() {
    return {
        type: actionCreator(PropertyTypes.EDIT_PROPERTY, 'res'),
    };
}

export function editPropertyErr() {
    return {
        type: actionCreator(PropertyTypes.EDIT_PROPERTY, 'err'),
    };
}

export function editPropertyFormCarriers(carriers) {
    return {
        type: PropertyTypes.EDIT_PROPERTY_FORM_CARRIERS,
        carriers,
    };
}
// E D I T   P R O P E R T Y


// L O A D   P R O P E R T Y   F O R    E D I T I N G   P R O P E R T Y   V A L U E S
export function loadPropertyForEditingPropertyValues(id) {
    return {
        type: PropertyTypes.LOAD_PROPERTY_FOR_EDITING_PROPERTY_VALUES,
        id,
    };
}

export function loadPropertyForEditingPropertyValuesRes() {
    return {
        type: actionCreator(PropertyTypes.LOAD_PROPERTY_FOR_EDITING_PROPERTY_VALUES, 'res'),
    };
}

export function loadPropertyForEditingPropertyValuesErr() {
    return {
        type: actionCreator(PropertyTypes.LOAD_PROPERTY_FOR_EDITING_PROPERTY_VALUES, 'err'),
    };
}
// L O A D   P R O P E R T Y   F O R E D I T I N G   P R O P E R T Y   V A L U E S


// L O A D   P R O P E R T Y   V A L U E S
export function loadPropertyValues(propertyID, pv) {
    return {
        type: PropertyTypes.LOAD_PROPERTY_VALUES,
        propertyID,
        pv,
    };
}

export function loadPropertyValuesRes(data) {
    return {
        type: actionCreator(PropertyTypes.LOAD_PROPERTY_VALUES, 'res'),
        data,
    };
}

export function loadPropertyValuesErr() {
    return {
        type: actionCreator(PropertyTypes.LOAD_PROPERTY_VALUES, 'err'),
    };
}
// L O A D   P R O P E R T Y   V A L U E S


// S E T   P R O P E R T Y   V A L U E S   F I L T E R S
export function setPropertyValuesFilters(key, value) {
    return {
        type: PropertyTypes.SET_PROPERTY_VALUES_FILTERS,
        key,
        value,
    };
}

export function setPropertyValuesFiltersRes(data) {
    return {
        type: actionCreator(PropertyTypes.SET_PROPERTY_VALUES_FILTERS, 'res'),
        data,
    };
}

export function setPropertyValuesPagination(key, value) {
    return {
        type: PropertyTypes.SET_PROPERTY_VALUES_PAGINATION,
        key,
        value,
    };
}

export function setPropertyValuesPaginationRes(data) {
    return {
        type: actionCreator(PropertyTypes.SET_PROPERTY_VALUES_PAGINATION, 'res'),
        data,
    };
}
// S E T   P R O P E R T Y   V A L U E S   F I L T E R S


// S E T   S E L E C T E D   P R O P E R T Y
export function setSelectedProperty(selected) {
    return {
        type: PropertyTypes.SET_SELECTED_PROPERTY,
        selected,
    };
}
// S E T   S E L E C T E D   P R O P E R T Y


// S E T   E D I T A B L E   P R O P E R T Y   V A L U E
export function setEditablePropertyValue(data) {
    return {
        type: PropertyTypes.SET_EDITABLE_PROPERTY_VALUE,
        data,
    };
}
// S E T   E D I T A B L E   P R O P E R T Y   V A L U E


// D E L E T E   P R O P E R T Y   V A L U E
export function deletePropertyValue(propertyId, propertyValueId) {
    return {
        type: PropertyTypes.DELETE_PROPERTY_VALUE,
        propertyId,
        propertyValueId,
    };
}

export function deletePropertyValueRes() {
    return {
        type: actionCreator(PropertyTypes.DELETE_PROPERTY_VALUE, 'res'),
    };
}

export function deletePropertyValueErr() {
    return {
        type: actionCreator(PropertyTypes.DELETE_PROPERTY_VALUE, 'err'),
    };
}
// D E L E T E   P R O P E R T Y   V A L U E
